import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'shortenString',
})

export class ShortStringPipe implements PipeTransform {
  transform(value: string, limit: number) {
    if (value && value.length > limit) {
      return value.substr(0, limit) + '...';
    }
    return value;
  }
}
